import React, { useState } from "react";
import PropTypes from "prop-types";
import { useWindowSize } from "@react-hook/window-size";
import { Row, Col } from "reactstrap";
import { Link } from 'react-router-dom';
import application_contants from "../../contants/application_contants";
import Strip from "../../customComponents/Strip/Strip";
import RenderPage from "../../customComponents/RenderPage/RenderPage";
import SEOComponent from "../../customComponents/SEO/SEOComponent";
import ExternalLayout from "../../customComponents/ExternalLayout/ExternalLayout";
import { Nav, NavItem, NavLink, TabContent, TabPane, Button, FormGroup, Label, Input, yy } from "reactstrap";
import classnames from 'classnames';
import PublicationService from "../../../api/services/PublicationService";
import debugLogger from '../../Utils/debugLogger';
import { ArrowBackIosOutlined, ArrowForwardIosOutlined } from '@material-ui/icons';
import Slider from "react-slick";
import moment from "moment";

const Publications = (props) => {
    const [width] = useWindowSize();
    const [activeTab, setActiveTab] = useState(0);
    const [data, setData] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [yearArrTitle, setYearArrTitle] = useState([]);
    const date = moment().format('yyyy');

    function SampleNextArrow(props) {
        const { className, style, onClick, arrowColor } = props;
        return (
            <div
                className={className}
                style={{ ...style, display: "block", }}
                onClick={onClick}
            >
                <ArrowForwardIosOutlined style={{ color: '#303030', fontSize: '1.4rem' }} />
            </div>
        );
    }

    function SamplePrevArrow(props) {
        const { className, style, onClick, arrowColor } = props;
        return (
            <div
                className={className}
                style={{ ...style, display: "block", }}
                onClick={onClick}
            >
                <ArrowBackIosOutlined style={{ color: '#303030', fontSize: '1.4rem' }} />
            </div>
        );
    }

    const settings = {
        loop: false,
        infinite: false,
        initialslide: 0,
        slidesToShow: width >= 1200 ? 10 : (width >= 768 && width <= 1023) ? 3 : 4,
        slidesToScroll: 1,
        nextArrow: <SampleNextArrow />,
    };

    const toggle = tab => {
        if (activeTab !== tab) setActiveTab(tab);
    }

    React.useEffect(() => {
        setData([]);
        window.scrollTo(0, 0);
        getList();
    }, [])

    const getList = async () => {
        setIsLoading(true);
        try {
            const res = await PublicationService.getPublicationList();

            if (res && res.success) {
                const payload = res.data || {};
                const list = Array.isArray(payload) ? payload : (payload.list || []);

                if (list.length > 0) {
                    const yearArr = [];
                    list.forEach((item) => {
                        yearArr.push(moment(item.date).format('yyyy'));
                    });

                    const yearArrFilter = yearArr.filter(function (item, pos) {
                        return yearArr.indexOf(item) == pos;
                    });

                    yearArr.sort(function (a, b) {
                        return a - b;
                    });
                    const sortedYears = yearArrFilter.sort((a, b) => b - a);
                    setYearArrTitle(sortedYears);

                    const lists = list.filter((it) => it.status === 1);
                    setData(lists);
                } else {
                    setData([]);
                    setYearArrTitle([]);
                }
            } else {
                debugLogger('getPublicationList: API returned failure', res);
                setData([]);
                setYearArrTitle([]);
            }
        } catch (err) {
            console.error('getPublicationList error', err);
            setData([]);
            setYearArrTitle([]);
        } finally {
            setIsLoading(false);
        }
    }

    const renderDesktopItem = (item, index) => {
        return <Col xs={12} sm={12} md={3} lg={12} xl={12} className="px-0 py-1 pb-4 challenges-card-br " key={index} >
            <Row className="mb-0 mx-0">
                <Row xs={12} sm={12} md={12} lg={12} xl={12} className={` p-3 publications-card`}>
                    <Col>
                        <Row xs={12} sm={12} md={12} lg={12} xl={12}>
                            <p className="h6-small section-title jostBold align-left publications-card-position">{item.title}</p>
                        </Row>
                        <Row xs={12} sm={12} md={12} lg={12} xl={12}>
                            <p className="p-large section-title jostRegular align-left pt-2 publications-card-position">{item.author}</p>
                        </Row>
                        <Row xs={12} sm={12} md={12} lg={12} xl={12}>
                            <p className="p-large section-title jostLight align-left pt-2 publications-card-position">{item.description}</p>
                        </Row>
                        <Row xs={12} sm={12} md={12} lg={12} xl={12}>
                            <a href={`${item.link}`} rel="noreferrer" target="_blank" className="p-medium section-title jostLight align-left  publications-card-position custom-reference-links">{item.link}</a>
                        </Row>
                    </Col>
                    {/* <Col xs={2} sm={2} md={2} lg={2} xl={2} className="align-right pt-5">
                        <Row >
                            <img src={application_contants.rightImg} alt="" className="right-icon--width" />
                        </Row>
                    </Col> */}
                </Row>
            </Row>
        </Col>
    }

    const renderMobileItem = (item, index) => {
        return <Col xs={12} sm={12} md={12} lg={12} xl={12} className="py-3 publications-card-br " key={index} >
            <Row className="mb-0 mx-0">
                <Row xs={12} sm={12} md={12} lg={12} xl={12} className={` p-1 publications-card`}>
                    <Col>
                        <Row xs={12} sm={12} md={12} lg={12} xl={12}>
                            <p className="h6-small section-title jostBold align-left publications-card-position">{item.title}</p>
                        </Row>
                        <Row xs={12} sm={12} md={12} lg={12} xl={12}>
                            <p className="p-large section-title jostRegular align-left pt-1 publications-card-position">{item.author}</p>
                        </Row>
                        <Row xs={12} sm={12} md={12} lg={12} xl={12}>
                            <p className="p-large section-title jostLight align-left pt-2 publications-card-position">{item.description}</p>
                        </Row>
                        <Row xs={12} sm={12} md={12} lg={12} xl={12}>
                            <a href={`${item.link}`} rel="noreferrer" target="_blank" className="p-medium section-title jostLight align-left  publications-card-position custom-reference-links">{item.link}</a>
                        </Row>
                    </Col>
                    {/* <Col xs={2} sm={2} md={2} lg={2} xl={2} className="align-right pt-5">
                        <Row >
                            <img src={application_contants.rightImg} alt="" className="right-icon--width" />
                        </Row>
                    </Col> */}
                </Row>
            </Row>
        </Col>
    }
    return (
        <ExternalLayout>
            <RenderPage
                id="tst-publications"
                className={`render px-0 ${props.isClassName ? ' render-page ' : 'min-height-auto'}`}
                containerType="container-fluid"
            >
                <SEOComponent
                    title="Publications"
                    keywords="SYnthesizing SPeech in INdian languages"
                    description="Speech recognition in agriculture and finance for the poor is an initiative predominantly to create resources and make them available as a digital public good"
                    siteUrl="/publications" />
                <Strip
                    id="tst-strip-publications"
                    className="strip strip-no-padding"
                    containerType="container">
                    <Row className="mx-2 pt-5">
                        <Col xs={12} sm={12} md={12} lg={12} xl={4} className="py-3 pt-5" >
                            {width <= application_contants.MOBILE_BREAKPOINT ? <h5 className="h5-medium jostRegular title-navy-blue section-title align-left ">Publications</h5> :
                                <h3 className="h5-medium jostRegular title-navy-blue section-title align-left">Publications</h3>}
                        </Col>

                        <Col xs={12} sm={12} md={12} lg={12} xl={12} className="pt-2">
                            <div>
                                <Col xs={10} sm={12} md={12} lg={11} xl={11} className="mx-0">
                                    <Slider {...settings}>

                                        {yearArrTitle.map((it, index) => (
                                            <Nav tabs className="tab-container align-left mx-0">
                                                <NavItem className="tab-nav-item " key={index}>
                                                    <NavLink
                                                        className={`tab-nav-link publication-date ${classnames({ active: activeTab === index })}`}
                                                        onClick={() => { toggle(index); }}
                                                    >
                                                        {it}
                                                    </NavLink>
                                                </NavItem>
                                            </Nav>
                                        ))}
                                    </Slider>
                                </Col>
                            </div>
                        </Col>
                        {yearArrTitle.length > 0 ?
                            <Row>
                                {yearArrTitle.length > 0 && yearArrTitle.map((it, index) => (
                                    <TabContent activeTab={activeTab}>
                                        <TabPane tabId={index} className="">
                                            <Row className="pt-5 mx-0">
                                                <Col xs={12} sm={12} md={12} lg={12} xl={12} className="px-0 m-auto">
                                                    {width >= application_contants.MOBILE_BREAKPOINT ?
                                                        <div className="pb-5">
                                                            <Row className="mx-0 pt-2 pb-2">
                                                                {data.length > 0 && data.map((item, index) =>
                                                                    moment(item.date).format('yyyy') === it ? renderDesktopItem(item, index) : null
                                                                )}
                                                            </Row>

                                                        </div>
                                                        :
                                                        <div className="pb-5">

                                                            <Row className="mx-0 pt-2 pb-2">
                                                                {data.length > 0 && data.map((item, index) =>
                                                                    moment(item.date).format('yyyy') === it ? renderMobileItem(item, index) : null
                                                                )}
                                                            </Row>

                                                        </div>
                                                    }
                                                </Col>
                                            </Row>
                                        </TabPane>
                                    </TabContent>

                                ))}

                            </Row>
                            :
                            <div className="pb-5 mb-5">
                                <h5 className="h5-small nunitoSans-SemiBold mb-0 pl-2 pr-2 pt-4 section-title align-left">
                                    <span className="h5-small section-title align-left pt-5 pl-2 title-navy-blue-medium"> Coming Soon...</span>
                                </h5 >
                            </div>
                        }
                    </Row>
                </Strip>
            </RenderPage>
        </ExternalLayout >
    );
};
Publications.defaultProps = {
    isClassName: true,
};
Publications.propTypes = {
    isClassName: PropTypes.bool,
};
export default Publications;